module.exports = __webpack_public_path__ + "static/media/meh-closed-eye.2e83cea0.svg";